import axios from "axios";
import env from "config";
import { useState } from "react";

const SsoHandler = () => {
  const BASE_URL = `${env.API_URL}/v1`;
  const [ssodata, setssodata] = useState("");

  const checkSSO = async (app) => {
    const searchParams = new URLSearchParams(document.location.search);
    const activepayload = searchParams.get("activepayload");

    let loadWithKeyBoard = false;
    document.addEventListener("keydown", (e) => {
      if (e.key === "F5" || e.ctrlKey || e.metaKey) {
        loadWithKeyBoard = true;
      }
    });

    window.addEventListener("beforeunload", () => {
      if (document.location.pathname.startsWith("/chat/") && !loadWithKeyBoard) {
        window.parent.postMessage({ action: "iframeReloaded" }, "*");
      }
    });

    // Parse the activepayload    
    let parsedObject = JSON.parse(decodeURIComponent(activepayload));

    if (parsedObject && parsedObject?.id) {
      const locationData = await axios
        .get(`${BASE_URL}/accounts/location?id=${parsedObject?.id}`)
        .then(function (response) {
          return response?.data?.data;
        })
        .catch(function (error) {
          return null;
        });

      if (locationData) {
        parsedObject = {
          ...parsedObject,
          ...locationData,
        };
      }
    }

    setssodata(parsedObject);
  };

  return {
    SSO: ssodata,
    checkSSO: checkSSO,
    setssodata,
  };
};
export default SsoHandler;
